module.exports = __webpack_public_path__ + "static/media/expandIcon.e60444b4.svg";